import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import SubAdminDetails from '../SubAdmins/SubAdminDetails/SubAdminDetails'
import {UsersListWrapper} from './users-list/UsersList'
import UsersDetailsPage from './UsersDetailsPage'
import AdsDetailsViewPage from './AdsDetailsViewPage'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Ticket Management',
    path: '/apps/all-ticket/ticket',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const UsersManagement = () => {
  return (
    <Routes>
      {/* <Route element={<Outlet />}> */}
      <Route
        path='ticket'
        element={
          <>
            <PageTitle breadcrumbs={usersBreadcrumbs}>Support Tickets</PageTitle>
            <UsersListWrapper />
          </>
        }
      />
      <Route path='ticket/details-page/:id/*' element={<AdsDetailsViewPage />} />

      {/* </Route> */}
      <Route element={<Navigate to='/apps/all-ticket/ticket' />} />
    </Routes>
  )
}

export default UsersManagement
